// The quiet bar that points at another step: a bold lead, a muted body and one
// pine "Go to" button. StepHeader uses it to point forward when a step is done;
// PrerequisiteHint uses it to point backwards when a step has nothing to work
// with. One component, so both directions read as one system.
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { JourneyStep } from '@/features/project/journey-steps';
import { useUIStore } from '@/stores';

export function StepLinkBar({ lead, body, target }: { lead: string; body: string; target: JourneyStep }) {
  const setViewMode = useUIStore((s) => s.setViewMode);
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border bg-card px-4 py-2.5 text-sm">
      <span>
        <span className="font-medium">{lead}</span> <span className="text-muted-foreground">{body}</span>
      </span>
      <Button variant="brand" size="sm" className="shrink-0" onClick={() => setViewMode(target.view)}>
        Go to {target.title}
        <ArrowRight className="h-4 w-4 ml-2" />
      </Button>
    </div>
  );
}
